import { DEFAULT_GRID_CELL_WIDTH } from '../constants'

export const multiplyByCellUnit = (count: number) => {
  return count * DEFAULT_GRID_CELL_WIDTH
}
